import { SavingActionTypes } from './types';

export interface SavingState {
  loading: boolean;
  wasSent: boolean;
  firstName: string;
  lastName: string;
  role: number;
  eventDate: string;
  email: string;
}

export const initialState: SavingState = {
  loading: false,
  wasSent: null,
  firstName: null,
  lastName: null,
  role: null,
  eventDate: null,
  email: null,
};

export function savingReducer(state = initialState, action: SavingActionTypes): SavingState {
  switch (action.type) {
    case 'SAVE_RESULTS_REQUESTED': {
      return { ...state, loading: true };
    }
    case 'SAVE_RESULTS_SUCCEEDED':
      return { ...state, ...action.payload, loading: false, wasSent: true };
    case 'SAVE_RESULTS_FAILED': {
      return { ...state, loading: false, wasSent: false };
    }
    default:
      return state;
  }
}
